import { RadioButton } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceRadioButton",
  mixins: [RadioButton, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    isDisabled() {
      return this.disabled || this._radioGroup.disabled || this._radioGroup.groupDisabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
